import { render, staticRenderFns } from "./MessagesView.vue?vue&type=template&id=1c9281c8&scoped=true"
import script from "./MessagesView.vue?vue&type=script&lang=js"
export * from "./MessagesView.vue?vue&type=script&lang=js"
import style0 from "./MessagesView.vue?vue&type=style&index=0&id=1c9281c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9281c8",
  null
  
)

export default component.exports